import split from "./split";
function splitHelper(list, ...args) {
  return list.map(item => split(item, ...args));
}

export default splitHelper;
